import { useConsentStore } from '@/stores/consent'

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID
let initialized = false
let defaultConsentSet = false

function isEnabled() {
    return import.meta.env.PROD && !!GA_MEASUREMENT_ID
}

function ensureGtagShim() {
    window.dataLayer = window.dataLayer || []
    if (typeof window.gtag !== 'function') {
        window.gtag = function () {
            window.dataLayer.push(arguments)
        }
    }
}

function consentGranted() {
    try {
        return useConsentStore().analyticsGranted
    } catch {
        return false
    }
}

export function setDefaultConsent() {
    if (defaultConsentSet) return
    defaultConsentSet = true

    ensureGtagShim()
    window.gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        wait_for_update: 500,
    })
}

export function updateConsent({ analytics, marketing }) {
    ensureGtagShim()
    window.gtag('consent', 'update', {
        analytics_storage: analytics ? 'granted' : 'denied',
        ad_storage: marketing ? 'granted' : 'denied',
        ad_user_data: marketing ? 'granted' : 'denied',
        ad_personalization: marketing ? 'granted' : 'denied',
    })
}

function loadGtagScript() {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`
    document.head.appendChild(script)

    ensureGtagShim()
    window.gtag('js', new Date())
    window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false })
}

export function trackEvent(eventName, params = {}) {
    if (!isEnabled() || typeof window.gtag !== 'function') return
    if (!consentGranted()) return
    window.gtag('event', eventName, params)
}

export function setGA4User(userData) {
    if (!isEnabled() || typeof window.gtag !== 'function') return
    if (!consentGranted()) return
    const domain = userData.email?.split('@')[1] || ''

    window.gtag('set', { user_id: userData.id, user: `${domain}-user-${userData.id}` || '' })
    window.gtag('set', 'user_properties', {
        owner_id: userData.owned_by,
        owner_domain: userData.owner_email?.split('@')[1] || '',
        user_type: userData.user_type,
        user_roles: userData.roles,
        account_plan: userData.account_plan,
        onboarding_status: userData.onboarding_status,
        signup_date: userData.registered_at,
        locale: userData.preferred_locale,
    })
}

export function markTimestamp(key) {
    sessionStorage.setItem(key, Date.now())
}

export function trackTimeSince(key, eventName, durationKey = 'duration_ms', params = {}) {
    const stored = sessionStorage.getItem(key)
    if (!stored) return
    const durationMs = Date.now() - parseInt(stored, 10)
    trackEvent(eventName, { [durationKey]: durationMs, ...params })
    sessionStorage.removeItem(key)
}

export function initGA4(router) {
    if (!isEnabled() || initialized) return
    initialized = true

    loadGtagScript()

    router.afterEach((to) => {
        const pageLocation = window.location.origin + to.path
        const settings = { page_location: pageLocation }
        if (document.referrer) settings.page_referrer = document.referrer.split('?')[0]
        window.gtag('set', settings)
        if (!consentGranted()) return
        window.gtag('event', 'page_view', {
            page_path: to.path,
            page_location: pageLocation,
            page_title: to.name || document.title,
        })
    })
}
